export default __webpack_public_path__ + "static/MessagingServer-251da400a4f2b439aa615ce1592e38ea.png";